import {Quiz, QuizCompletion, QuizSharePlatform, QuizYearHistoryMonth} from '../models/quiz.models';

export namespace QuizActions {
  export class FetchCurrent {
    static readonly type = '[Quiz] Fetch Current';
  }

  export class SubmitCompletion {
    static readonly type = '[Quiz] Submit Completion';
    constructor(public quizId: number, public answers: {quiz_question_id: number; answer_id: number}[]) {}
  }

  export class RecordShare {
    static readonly type = '[Quiz] Record Share';
    constructor(public completionId: number, public platform: QuizSharePlatform) {}
  }

  export class FetchYearHistory {
    static readonly type = '[Quiz] Fetch Year History';
    constructor(public year: number) {}
  }

  export class SetCurrent {
    static readonly type = '[Quiz] Set Current';
    constructor(public quiz: Quiz | null, public completion: QuizCompletion | null) {}
  }

  export class SetCompletion {
    static readonly type = '[Quiz] Set Completion';
    constructor(public completion: QuizCompletion) {}
  }

  export class SetYearHistory {
    static readonly type = '[Quiz] Set Year History';
    constructor(public year: number, public months: QuizYearHistoryMonth[]) {}
  }

  export class Reset {
    static readonly type = '[Quiz] Reset';
  }
}
